import * as React from "react";
export const DadosBasicosBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
